import { Button } from '@components';
import { baseURL } from '@services/env-variables';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { AnoMesReferencia } from '../components';

export const ExtratoSaldoContaPage = () => {
  const navigate = useNavigate();
  const { matricula, plano, token } = useSelector((state) => state.user.data);
  const status = useSelector((state) => state.user.dadosPessoais?.statusPlano);
  const tituloPagina =
    status === 'Ativo'
      ? 'Emitir Extrato de Saldo de Contas'
      : 'Extrato da Conta de Aposentadoria';
  const [urlPDFExtrato, setUrlPDFExtrato] = useState('');

  useEffect(() => {
    setUrlPDFExtrato(
      `${baseURL}GerarExtratoMensal?matricula=${matricula}&token=${token}&plano=${plano}&anomes=`
    );
  }, [matricula, plano, status, token]);

  return (
    <>
      <Helmet>
        <title>Forluz - {tituloPagina}</title>
      </Helmet>
      <h1 className="page-title mb-3">
        <strong>{tituloPagina}</strong>&nbsp;
      </h1>
      <hr className="my-4" />
      <div className="d-flex col-3 col-md-2 col-lg-1 justify-content-center">
        <Button
          className="justify-content-center mb-32"
          transparent
          color="orange"
          icon="arrow_back"
          onClick={() => navigate(-1)}
        >
          Voltar
        </Button>
      </div>
      {urlPDFExtrato && (
        <AnoMesReferencia
          urlGetPDF={urlPDFExtrato}
          titleCard={
            status === 'Ativo' || status === 'Assistido'
              ? 'Extrato'
              : 'Benefício Mensal'
          }
        />
      )}
    </>
  );
};
